import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Link } from '@comparethemarketau/manor-link';
import { Typography } from '@comparethemarketau/manor-typography';
import { Row, Column, Container } from '@comparethemarketau/manor-grid';

const useStyles = createUseStyles((theme) => ({
    text: {
        fontSize: 'inherit'
    }
}));

const FooterDisclaimer = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { className } = props;

    return (
        <Container className={classNames('test-footer-disclaimer', className)}>
            <Row>
                <Column>
                    <Typography className={classes.text}>
                        We recommend you read the
                        {' '}
                        <strong>{'Product Disclosure Statement (PDS)'}</strong>
                        {' '}
                        before you make a decision.
                    </Typography>
                </Column>
            </Row>
            <Row>
                <Column>
                    <Typography className={classes.text}>
                        Please note that when we display quotes on our comparison results page, they are indicative and subject to change based on further questions by the insurer.
                    </Typography>
                </Column>
            </Row>
            <Row>
                <Column>
                    <Typography className={classes.text}>
                        We do not compare all car insurers or products in the market. Any advice given above is general and does not take into account your objectives, financial situation or needs. You should consider whether the advice is suitable for you and your personal circumstances, and before you make any decision about whether to purchase a product, you should read the PDS for that product. A number of the car insurance brands on our panel are arranged by Auto & General Services Pty Ltd ACN 003 617 909 on behalf of the insurer Auto & General Insurance Company Limited ACN 111 586 353, both of which are related entities of Compare the Market Pty Ltd. Our relationship with those companies does not impact the integrity of our comparison service, and we continue to work hard to encourage brands that do not currently participate on our comparison service to come on board.
                    </Typography>
                </Column>
            </Row>
            <Row>
                <Column>
                    <Typography className={classes.text}>
                        {'For more information about the range of insurers and products we compare, how our service works, and how we make our money (remembering that the service is free for you to use), read our'}
                        <Link
                            underline="none"
                            target="_blank"
                            trackingLabel="link for https://www.comparethemarket.com.au/car-insurance/disclosures/"
                            href="https://www.comparethemarket.com.au/car-insurance/disclosures/"
                        >
                            {' how our comparison works '}
                        </Link>
                        {'page, and read our'}
                        <Link
                            underline="none"
                            target="_blank"
                            trackingLabel="link for https://secure.comparethemarket.com.au/static/legal/FSG.pdf"
                            href="https://secure.comparethemarket.com.au/static/legal/FSG.pdf"
                        >
                            {' Financial Services Guide (General Insurance Products).'}
                        </Link>
                    </Typography>
                </Column>
            </Row>
            <Row removeMarginBottom>
                <Column>
                    <Typography className={classes.text}>
                        The Compare The Market website and trading name are owned by Compare The Market Pty Ltd ACN 117 323 378 AFSL 422926.
                    </Typography>
                </Column>
            </Row>
        </Container>
    );
};

FooterDisclaimer.propTypes = {
    className: PropTypes.string
};

export { FooterDisclaimer };
